export const MessageListBottomPlaceholder = () => (
  <div className="message-list__bottom-placeholder" data-test="message-list__bottom-placeholder" />
);
